<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [emptyState]="{ title: 'No hay logs de reenvíos' }"
></app-tabla>
